"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const ListSharedTracks_1 = __importDefault(require("./ListSharedTracks"));
const ModalSharedTracks = ({ trackConfigs, title, onCloseModal }) => {
    const filteredTracks = trackConfigs?.filter((trackConfig) => trackConfig?.displayOnResult);
    return (react_1.default.createElement(Modal_1.default, { minWidth: 400, customClass: "max-w-[400px]", onClose: onCloseModal },
        react_1.default.createElement(Modal_1.default.Header, { title: title.replace(/([a-z](?=[A-Z]))/g, '$1 '), onClose: onCloseModal }),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("div", { className: "px-[24px]" },
                react_1.default.createElement("p", { className: "typography-paragraph text-n-600 mb-[14px]" }, (0, HelperUtils_1.getObjectiveLocale)('Reviewee will see this shared tracks')),
                filteredTracks?.length > 0 &&
                    filteredTracks.map((trackConfig) => (react_1.default.createElement(ListSharedTracks_1.default, { key: trackConfig.type, trackName: trackConfig.name, trackType: trackConfig.type })))))));
};
exports.default = ModalSharedTracks;
